import { IconButton } from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

type Props = {
  isOpen: boolean;
  title: string | ReactNode;
  children: ReactNode;
  onClose: () => void;
  onDelete?: () => void;
};

export const PANEL_WIDTH = 576;

export const FloatingPanel = ({
  children,
  isOpen,
  title,
  onClose,
  onDelete,
}: Props) => {
  return isOpen ? (
    <div className="border-border-default bg-background-primary-default shadow-l absolute top-0 right-0 z-50 m-0 flex h-full w-[576px] flex-col border-0 border-l border-solid p-0">
      <div className="border-b-border-default flex items-center justify-between border-0 border-b border-solid px-32 py-16">
        <div className="text-content-primary title-xl">{title}</div>
        <div className="flex gap-8">
          {onDelete && (
            <IconButton
              aria-label="delete"
              onClick={onDelete}
              iconName="trash"
            />
          )}
          <IconButton aria-label="cross" onClick={onClose} iconName="cross" />
        </div>
      </div>
      <div className="relative flex h-[calc(100%_-_142px)] grow flex-col">
        {children}
      </div>
    </div>
  ) : null;
};
